import ubdb from './ub+db';
import ubdDiagonal from './ub+d-diagonal';
import udDiagonal from './u+d-diagonal';
import uDiagonal from './u-diagonal';
import ur from './ur';

export default {
  cases: [
    ur,
    uDiagonal,
    ubdb,
    udDiagonal,
    ubdDiagonal,
  ],
  name: 'PBL Cases',
};
